import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/regenerator";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { createNoDashGuid, Deferred, Events } from "../common/Exports";
import { PullAudioOutputStreamImpl } from "../sdk/Audio/AudioOutputStream";
import { SynthesisAdapterBase } from "./SynthesisAdapterBase";
import { ConnectingToSynthesisServiceEvent, SynthesisStartedEvent, SynthesisTriggeredEvent } from "./SynthesisEvents";
export var SynthesisTurn = /*#__PURE__*/function () {
  function SynthesisTurn() {
    var _this = this;

    _classCallCheck(this, SynthesisTurn);

    this.privIsDisposed = false;
    this.privIsSynthesizing = false;
    this.privIsSynthesisEnded = false;
    this.privBytesReceived = 0;
    this.privInTurn = false;
    this.privTextOffset = 0;
    this.privNextSearchTextIndex = 0;

    this.onPreConnectionStart = function (authFetchEventId, connectionId) {
      _this.privAuthFetchEventId = authFetchEventId;

      _this.onEvent(new ConnectingToSynthesisServiceEvent(_this.privRequestId, _this.privAuthFetchEventId));
    };

    this.onAuthCompleted = function (isError, error) {
      if (isError) {
        _this.onComplete();
      }
    };

    this.onConnectionEstablishCompleted = function (statusCode, reason) {
      if (statusCode === 200) {
        _this.onEvent(new SynthesisStartedEvent(_this.requestId, _this.privAuthFetchEventId));

        _this.privBytesReceived = 0;
        return;
      } else if (statusCode === 403) {
        _this.onComplete();
      }
    };

    this.onServiceResponseMessage = function (responseJson) {
      var response = JSON.parse(responseJson);
      _this.streamId = response.audio.streamId;
    };

    this.onServiceTurnEndResponse = function () {
      _this.privInTurn = false;

      _this.privTurnDeferral.resolve();

      _this.onComplete();
    };

    this.onServiceTurnStartResponse = function () {
      if (!!_this.privTurnDeferral && !!_this.privInTurn) {
        // What? How are we starting a turn with another not done?
        _this.privTurnDeferral.reject("Another turn started before current completed."); // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited

        /* tslint:disable:no-empty */


        _this.privTurnDeferral.promise.then().catch(function () {});
      }

      _this.privInTurn = true;
      _this.privTurnDeferral = new Deferred();
    };

    this.dispose = function (error) {
      if (!_this.privIsDisposed) {
        // we should have completed by now. If we did not its an unknown error.
        _this.privIsDisposed = true;
      }
    };

    this.onEvent = function (event) {
      Events.instance.onEvent(event);
    };

    this.onComplete = function () {
      if (_this.privIsSynthesizing) {
        _this.privIsSynthesizing = false;
        _this.privIsSynthesisEnded = true;

        _this.privAudioOutputStream.close();

        _this.privInTurn = false;

        if (_this.privTurnAudioDestination !== undefined) {
          _this.privTurnAudioDestination.close();

          _this.privTurnAudioDestination = undefined;
        }
      }
    };

    this.privRequestId = createNoDashGuid();
    this.privTurnDeferral = new Deferred(); // We're not in a turn, so resolve.

    this.privTurnDeferral.resolve();
  }

  _createClass(SynthesisTurn, [{
    key: "requestId",
    get: function get() {
      return this.privRequestId;
    }
  }, {
    key: "streamId",
    get: function get() {
      return this.privStreamId;
    },
    set: function set(value) {
      this.privStreamId = value;
    }
  }, {
    key: "audioOutputFormat",
    get: function get() {
      return this.privAudioOutputFormat;
    },
    set: function set(format) {
      this.privAudioOutputFormat = format;
    }
  }, {
    key: "turnCompletionPromise",
    get: function get() {
      return this.privTurnDeferral.promise;
    }
  }, {
    key: "isSynthesisEnded",
    get: function get() {
      return this.privIsSynthesisEnded;
    }
  }, {
    key: "isSynthesizing",
    get: function get() {
      return this.privIsSynthesizing;
    }
  }, {
    key: "currentTextOffset",
    get: function get() {
      return this.privTextOffset;
    } // The number of bytes received for current turn

  }, {
    key: "bytesReceived",
    get: function get() {
      return this.privBytesReceived;
    }
  }, {
    key: "getAllReceivedAudio",
    value: function getAllReceivedAudio() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.privReceivedAudio) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(this.privReceivedAudio));

              case 2:
                if (this.privIsSynthesisEnded) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", null);

              case 4:
                _context.next = 6;
                return this.readAllAudioFromStream();

              case 6:
                return _context.abrupt("return", Promise.resolve(this.privReceivedAudio));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getAllReceivedAudioWithHeader",
    value: function getAllReceivedAudioWithHeader() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var audio;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.privReceivedAudioWithHeader) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", this.privReceivedAudioWithHeader);

              case 2:
                if (this.privIsSynthesisEnded) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", null);

              case 4:
                if (!this.audioOutputFormat.hasHeader) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 7;
                return this.getAllReceivedAudio();

              case 7:
                audio = _context2.sent;
                this.privReceivedAudioWithHeader = SynthesisAdapterBase.addHeader(audio, this.audioOutputFormat);
                return _context2.abrupt("return", this.privReceivedAudioWithHeader);

              case 12:
                return _context2.abrupt("return", this.getAllReceivedAudio());

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "startNewSynthesis",
    value: function startNewSynthesis(requestId, rawText, isSSML, audioDestination) {
      this.privIsSynthesisEnded = false;
      this.privIsSynthesizing = true;
      this.privRequestId = requestId;
      this.privRawText = rawText;
      this.privIsSSML = isSSML;
      this.privAudioOutputStream = new PullAudioOutputStreamImpl();
      this.privAudioOutputStream.format = this.privAudioOutputFormat;
      this.privReceivedAudio = null;
      this.privReceivedAudioWithHeader = null;
      this.privBytesReceived = 0;
      this.privTextOffset = 0;
      this.privNextSearchTextIndex = 0;
      this.privPartialVisemeAnimation = "";

      if (audioDestination !== undefined) {
        this.privTurnAudioDestination = audioDestination;
        this.privTurnAudioDestination.format = this.privAudioOutputFormat;
      }

      this.onEvent(new SynthesisTriggeredEvent(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    }
  }, {
    key: "onAudioChunkReceived",
    value: function onAudioChunkReceived(data) {
      if (this.isSynthesizing) {
        this.privAudioOutputStream.write(data);
        this.privBytesReceived += data.byteLength;

        if (this.privTurnAudioDestination !== undefined) {
          this.privTurnAudioDestination.write(data);
        }
      }
    }
  }, {
    key: "onWordBoundaryEvent",
    value: function onWordBoundaryEvent(text) {
      this.updateTextOffset(text);
    }
  }, {
    key: "onVisemeMetadataReceived",
    value: function onVisemeMetadataReceived(metadata) {
      if (metadata.Data.AnimationChunk !== undefined) {
        this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
      }
    }
  }, {
    key: "onStopSynthesizing",
    value: function onStopSynthesizing() {
      this.onComplete();
    }
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */

  }, {
    key: "getAndClearVisemeAnimation",
    value: function getAndClearVisemeAnimation() {
      var animation = this.privPartialVisemeAnimation;
      this.privPartialVisemeAnimation = "";
      return animation;
    }
  }, {
    key: "updateTextOffset",
    value: function updateTextOffset(text) {
      if (this.privTextOffset >= 0) {
        this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);

        if (this.privTextOffset >= 0) {
          this.privNextSearchTextIndex = this.privTextOffset + text.length;
        }

        if (this.privIsSSML) {
          if (this.privRawText.indexOf("<", this.privTextOffset + 1) > this.privRawText.indexOf(">", this.privTextOffset + 1)) {
            this.updateTextOffset(text);
          }
        }
      }
    }
  }, {
    key: "readAllAudioFromStream",
    value: function readAllAudioFromStream() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.privIsSynthesisEnded) {
                  _context3.next = 10;
                  break;
                }

                this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
                _context3.prev = 2;
                _context3.next = 5;
                return this.privAudioOutputStream.read(this.privReceivedAudio);

              case 5:
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](2);
                this.privReceivedAudio = new ArrayBuffer(0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 7]]);
      }));
    }
  }]);

  return SynthesisTurn;
}();